import { Component, ViewChild } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, NotificationDispatch } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationDispatchEndpoint } from '@m4u-angular/core/endpoints/notification-dispatch.endpoint';
import { EnumMessageBoxTypes, EnumNotificationDeliveryOptions } from '@m4u-angular/core/framework/sysenums.enum';
import { MessageBoxDialogComponent } from '@m4u-angular/ui/dialogs/messagebox-dialog/messageboxdialog.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-dispatch-grid',
    templateUrl: './notification-dispatch-grid.component.html',
    styleUrls: ['./notification-dispatch-grid.component.scss']
})
export class NotificationDispatchGridComponent extends BaseGridComponent<NotificationDispatch, BaseState> {
    @ViewChild('messageDialog') messageDialog: MessageBoxDialogComponent;
    
    constructor(A: ServiceBagService,
        private notificationDispatchEndpoint: NotificationDispatchEndpoint) {
        super(A, 'NotificationDispatchGridComponent', NotificationDispatch, BaseState);
    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [
            {
                text: this.RC('btnCancelNotifications'),
                visible: options?.data?.CanCancel,
                onClick: () => this.OnCancelPushNotifications(options)
            }
        ];
    }

    private OnCancelPushNotifications(options: any) {
        if(!options?.data?.DeliveryMethod || !options?.data?.EntryID) {
            return;
        }

        this.messageDialog.Type = EnumMessageBoxTypes.YesNo;
        this.messageDialog.Prompt = this.RC('lblCancelNotificationsPrompt');
        
        this.messageDialog.ShowDialogShort(() => {
            this.Do(
                this.notificationDispatchEndpoint.CancelPushNotification(options.data.EntryID), 
                true, 
                () => {
                    this.NotifyEntitySaved(undefined, NotificationDispatch);
                }
            );
        });        
    }
}